// src/contexto/ProductosContext.jsx
import { createContext, useContext, useState,useCallback } from "react";

import { crearProductoPrecioUseCase } from "../../../core/productos/application/crearProductoConPrecio.usecase.js";
import {actualizarProductoPrecioUseCase } from "../../../core/productos/application/actualizarProductoConPrecio.usecase.js";


import { obtenerProductosPrecioUseCase } from "../../../core/productos/application/obtenerProductoPrecio.usecase.js";
import { obtenerProductosInsumosUseCase } from "../../../core/productos/application/obtenerProductoInsumo.usecase.js";


const ProductosContext = createContext(null);

export const useProductos = () => {
  const ctx = useContext(ProductosContext);
  if (!ctx) {
    throw new Error("useProductosPrecio debe usarse dentro de ProductosProvider");
  }
  return ctx;
};

export function ProductosProvider({ children }) {

  const [productos, setProductos] = useState([]);
  const [insumos, setInsumos] = useState([]);
  const [productosFiltrados, setProductosFiltrados] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

// Devuelve los productos o insumos y un objeto de estado
const cargarProductos = useCallback(async () => {
  setCargando(true);
  setError(null);

  const res = await obtenerProductosPrecioUseCase();
  console.log("respuesta productos:", res);

if (res.success) {
    setProductos(res.data.data);
  setProductosFiltrados(res.data.data);
} else {
  setError(res.error);
}

  setCargando(false);
}, []);

const cargarProductosInsumos = useCallback(async () => {
  setCargando(true);
  setError(null);

  const res = await obtenerProductosInsumosUseCase();
  console.log("respuesta insumos:", res);
  if (res.success)   
  setInsumos(res.data.data);
  else setError(res.error);

  setCargando(false);
}, []);

  // 🟢 Agregar producto
  const agregarProducto = async (producto) => {
    setCargando(true);
    setError(null);

    const res = await crearProductoPrecioUseCase(producto);

    if (res.success) {
      const nuevo = res.data[0];
      setProductos(prev => [...prev, nuevo]);
      setProductosFiltrados(prev => [...prev, nuevo]);
    } else {
      setError(res.error);
    }

    setCargando(false);
    return res;
  };


// 🟡 Actualizar producto
const actualizarProducto = async (id, cambios) => {
  setCargando(true);
  setError(null);

  try {
    console.log("ID:", id);
    console.log("Cambios:", cambios);

    const res = await actualizarProductoPrecioUseCase(id, cambios);

    if (!res.success) {
      setError(res.error);
      return res;
    }

    const actualizado = res.data[0];

    // función reutilizable
    const actualizarLista = (lista) =>
      lista.map((p) => (p.id === id ? actualizado : p));

    setProductos((prev) => actualizarLista(prev));
    setProductosFiltrados((prev) => actualizarLista(prev));
    setInsumos((prev) => actualizarLista(prev));

    return res;

  } catch (err) {
    console.error("Error inesperado:", err);
    setError(err.message);
    return { success: false, error: err.message };

  } finally {
    setCargando(false);
  }
};


  // 🔴 Eliminar producto
  const borrarProducto = async (id) => {
    setCargando(true);
    setError(null);

    const res = await crearProductoPrecioUseCase(id);

    if (res.success) {
      setProductos(prev => prev.filter(p => p.id !== id));
      setProductosFiltrados(prev => prev.filter(p => p.id !== id));
      setInsumos(prev => prev.filter(p => p.id !== id));
    } else {
      setError(res.error);
    }

    setCargando(false);
    return res;
  };

  // 🔍 Filtros sobre TODOS los productos
  const filtrarPorNombre = (termino) => {
    const t = termino.toLowerCase();
    setProductosFiltrados(
      productos.filter(p =>
        p.nombre.toLowerCase().includes(t)
      )
    );
  };

  const filtrarPorCategoria = (categoria) => {
    if (!categoria) {
      setProductosFiltrados(productos);
      return;
    }

    setProductosFiltrados(
      productos.filter(p => p.categoria === categoria)
    );
  };

  return (
    <ProductosContext.Provider
      value={{
        productos,
        insumos,
        productosFiltrados,
        cargarProductos,
        cargarProductosInsumos,
        agregarProducto,
        actualizarProducto,
        borrarProducto,
        filtrarPorNombre,
        filtrarPorCategoria,
        cargando,
        error
      }}
    >
      {children}
    </ProductosContext.Provider>
  );
}